<template>
  <div>
    <v-app-bar
      app
      :color="color"
      :flat="flat"
      dark
      class="px-15"
      :class="{ expand: flat }"
    >
      <v-toolbar-title>
        <v-img src="@/assets/img/logo-small.png" max-width="50px" />
      </v-toolbar-title>
      <v-spacer />
      <v-app-bar-nav-icon
        @click.stop="drawer = !drawer"
        class="mr-4"
        v-if="isXs"
      />
      <div v-else>
        <v-btn
          v-for="([icon, text, link]) in items"
          :key="link"
          text
          @click="naviItemClick(link)"
        >
          <span class="mr-2">{{ text }}</span>
        </v-btn>
      </div>
    </v-app-bar>
  </div>
</template>

<style scoped>
.v-toolbar {
  transition: 0.6s;
}
.expand {
  height: 80px !important;
  padding-top: 10px;
}
</style>

<script>
export default {
  data: () => ({
    drawer: null,
    isXs: false,
    items: [
      ["icon1", "首页", "/"],
      ["mdi-information-outline", "功能", "/?scrollTo=#features"],
      ["mdi-email-outline", "产品案例", "/products"],
      ["mdi-download-box-outline", "关于我们", "/?scrollTo=#about"],
      // ["mdi-download-box-outline", "下载", "#download"],
      // ["mdi-currency-usd", "价格", "#pricing"],
      ["mdi-email-outline", "联系我们", "/?scrollTo=#contact"],
    ],
  }),
  props: {
    color: String,
    flat: Boolean,
  },
  methods: {
    onResize() {
      this.isXs = window.innerWidth < 850;
    },
    naviItemClick(link) {
      if (link.startsWith("/")) {
        this.$router.push(link);
      } else {
        this.$vuetify.goTo(link);
      }
    },
  },

  watch: {
    isXs(value) {
      if (!value) {
        if (this.drawer) {
          this.drawer = false;
        }
      }
    },
  },
  mounted() {
    this.onResize();
    window.addEventListener("resize", this.onResize, { passive: true });
  },
};
</script>
